import React from "react"
import PropTypes from "prop-types"
import TreeNode from "./Node"
import IdGenerator from "../../../IdGenerator"

const generator = new IdGenerator()

const TreeBody = ({ root, headers, tr }) => (
  <tbody className="bookmark-widget-table-tbody">
    {root.children.map((node) => (
      <TreeNode
        data={node}
        headers={headers}
        key={generator.getId(node)}
        tr={tr}
        level={0}
      />
    ))}
  </tbody>
)

TreeBody.propTypes = {
  root: PropTypes.object.isRequired,
  headers: PropTypes.array.isRequired,
  tr: PropTypes.object
}

TreeBody.defaultProps = {
  tr: undefined
}

export default TreeBody
